import React from 'react';
import './InternetDetail.css';
import iconBack from '../../assets/images/icon-back.svg';

interface InternetDetailProps {
  onBack: () => void;
}

const InternetDetail: React.FC<InternetDetailProps> = ({ onBack }) => {
  return (
    <div className="internet-detail-container">
      <div className="internet-detail-header">
        <button className="back-btn" onClick={onBack}>
          <img src={iconBack} alt="뒤로가기" />
        </button>
      </div>

      <div className="internet-detail-content">
        <h1 className="detail-title">상세요금</h1>

        <div className="detail-section">
          <h2 className="detail-section-title">상세 요금 정보</h2>
          <div className="detail-card">
            <div className="detail-row">
              <span className="detail-label">인터넷</span>
              <span className="detail-value">39,600 원</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">공유기</span>
              <span className="detail-value">1,100 원</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">E·USIM</span>
              <span className="detail-value">0 원</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">TV</span>
              <span className="detail-value">14,300 원</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">전화</span>
              <span className="detail-value">3,500 원</span>
            </div>

            <div className="detail-divider" />

            <div className="detail-row highlight">
              <div className="detail-label-group">
                <span className="detail-label">기본 요금</span>
                <span className="detail-sub">(매월)</span>
              </div>
              <span className="detail-value primary">58,500 원</span>
            </div>

            <div className="detail-row">
              <span className="detail-label">핸드폰 결합 할인시</span>
              <span className="detail-value gray">-2,000 원</span>
            </div>

            <div className="detail-row">
              <span className="detail-label">TV 동시 결합 할인시</span>
              <span className="detail-value gray">-1,000 원</span>
            </div>

            <div className="detail-divider" />

            <div className="detail-row highlight">
              <div className="detail-label-group">
                <span className="detail-label">총 요금 예상</span>
                <span className="detail-sub">(매월)</span>
              </div>
              <span className="detail-value special">55,500 원</span>
            </div>
          </div>
        </div>

        <div className="detail-divider-thick" />

        <div className="detail-section">
          <h2 className="detail-section-title">받을 수 있는 할인 혜택</h2>
          <p className="detail-section-desc">
            선택하신 서비스로 받으실 수 잇는 혜택을 알려드려요!
          </p>
          <div className="benefit-tags">
            <span className="benefit-tag">TV 동시결합 할인</span>
            <span className="benefit-tag">
              통신사 Usim 이동시 최대 140만원 사은품‼️
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternetDetail;
